'use strict';

/**
 * @ngdoc service
 * @name gfcmsApp.exceptionhandler.provider
 * @description
 * # exceptionhandler.provider
 * Provider in the gfcmsApp.
 */
angular.module('gfcmsApp')
  .factory('exceptionhandlerProvider', function () {

    function handle(exception, cause) {
      //errorlogService.log(exception, cause);
    }
  });
